/**
 * Removes falsy values from an array
 * @param arr Array to sift
 * @returns Array with falsy values removed
 */
export function sift<T extends Array<unknown>>(arr: T) {
  return arr.filter((item) => item);
}
